import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  instrumentGroupsPropTypes, pipeConfigsPropTypes, runPropTypes, userPropTypes
} from 'common/propTypes';
import LiveMonitor from '../LiveMonitor/index';
import { OrderContext } from '../../OrderStore/index';
import TradeSkipDates from './TradeSkipDates';
import TransactionDetail from '../TransactionDetail/index';

const propTypes = {
  instrumentGroups: instrumentGroupsPropTypes.isRequired,
  pipeConfigs: pipeConfigsPropTypes.isRequired,
  run: runPropTypes.isRequired,
  jobIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  currentUser: userPropTypes
};

const defaultProps = { currentUser: null };

const LiveDetails = ({
  instrumentGroups, pipeConfigs, run, jobIds, currentUser
}) => {
  const { isLoading } = useContext(OrderContext);

  const currentUserId = _.get(currentUser, 'id', null);
  const runUserId = _.get(run, 'user_id', null);
  const isOwnRun = currentUserId === runUserId;

  return (
    <div className="position-relative">
      <TradeSkipDates run={run} currentUser={currentUser} />
      <LiveMonitor
        run={run}
        jobIds={jobIds}
        onOrderReceived={() => { }}
        instrumentGroups={instrumentGroups}
        pipeConfigs={pipeConfigs}
        isOwnRun={isOwnRun}
      />
      {!isLoading && <div><TransactionDetail run={run} /></div>}
    </div>
  );
};

export default LiveDetails;

LiveDetails.propTypes = propTypes;
LiveDetails.defaultProps = defaultProps;
